import { StorylineLeadTextModelType } from '@/types/cms/Storylines'
import styles from './StorylineLeadText.module.scss'

export default function StorylineLeadText({ item }: { readonly item: { model: StorylineLeadTextModelType } }) {
  return <div className={styles.leadtext}>{item.model.fields['lead-text']?.value}</div>
}
